export const defaultImgs = [
  "https://openseauserdata.com/files/3d74523702ca8c610fe09754048575f5.jpg",
  "https://ipfs.moralis.io:2053/ipfs/QmNgA9MNWFfRaoKzBt21VghQopnKXBgVxzyGvv5qjsV4Vw/media/2",
];
